import { render, staticRenderFns } from "./sk-policy.vue?vue&type=template&id=4bff615b&"
import script from "./sk-policy.vue?vue&type=script&lang=js&"
export * from "./sk-policy.vue?vue&type=script&lang=js&"
import style0 from "./sk-policy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports